import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const cardVariants = {
  initial: { opacity: 0, y: 50 },
  animate: { opacity: 1, y: 0 }
};

export default function ServicesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  const cards = [
    { title: 'Selidbe', img: '/assets/images/moving1.jpg' },
    { title: 'Pakovanje', img: '/assets/images/moving2.jpg' },
    { title: 'Skladištenje', img: '/assets/images/moving3.jpg' },
  ];

  return (
    <section ref={ref} style={{ padding: '40px 0' }}>
      <div className="services-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:16 }}>
        {cards.map((c, i) => (
          <motion.article key={c.title} variants={cardVariants} initial="initial" animate={isInView ? 'animate' : 'initial'} transition={{ duration: 0.5, delay: 0.2 + i*0.15 }} style={{ border:'1px solid #e5e7eb', borderRadius: 12, overflow:'hidden', background:'#fff' }}>
            <img src={process.env.PUBLIC_URL + c.img} alt={c.title} style={{ width:'100%', height:'clamp(140px, 22vw, 200px)', objectFit:'cover', display:'block' }} />
            <div style={{ padding: 16 }}>
              <h3 style={{ marginBottom:8 }}>{c.title}</h3>
              <p style={{ color:'#475569' }}>Profesionalno i sigurno.</p>
            </div>
          </motion.article>
        ))}
  </div>
  <style>{`@media (max-width: 900px){ .services-grid{ grid-template-columns: 1fr 1fr; } } @media (max-width: 600px){ .services-grid{ grid-template-columns: 1fr; } }`}</style>
    </section>
  );
}
